import { render, staticRenderFns } from "./dragFormTab.vue?vue&type=template&id=55e75122&"
import script from "./dragFormTab.vue?vue&type=script&lang=js&"
export * from "./dragFormTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports